var JobMatchMeetingsFeedbackModalController = /** @class */ (function () {
    function JobMatchMeetingsFeedbackModalController() {
        // this.jobMatchId = this.resolve.jobMatchId
        // this.jobId = this.resolve.jobId;
        // this.candidateId = this.resolve.candidateId;
        // this.feedbackType = this.resolve.feedbackType;
        // this.meetingUserList = this.resolve.meetingUserList;
        // this.parentScheduleId = this.resolve.parentScheduleId;
        // this.childScheduleId = this.resolve.childScheduleId;
    }
    JobMatchMeetingsFeedbackModalController.prototype.$onInit = function () {
        var _this = this;
        this.jobMatchId = this.resolve.jobMatchId;
        this.jobId = this.resolve.jobId;
        this.candidateId = this.resolve.candidateId;
        this.feedbackType = this.resolve.feedbackType;
        this.meetingUserList = this.resolve.meetingUserList;
        this.parentScheduleId = this.resolve.parentScheduleId;
        this.childScheduleId = this.resolve.childScheduleId;
        this.callbackObject = { callbackType: 'cancel', entity: {} };
        this.feedbackUserIdsList = [];
        this.title = 'Interview Feedback';
        if (this.feedbackType == 'PhoneScreen') {
            this.title = 'Phone Screen Feedback';
            this.workflowStep = 'ps';
        }
        else {
            this.workflowStep = 'in';
        }
        angular.forEach(this.meetingUserList, function (val, key) {
            _this.feedbackUserIdsList.push(val.userId);
        });
    };
    JobMatchMeetingsFeedbackModalController.prototype.closeModal = function () {
        this.modalInstance.close(this.callbackObject);
    };
    JobMatchMeetingsFeedbackModalController.prototype.dismissModal = function () {
        this.modalInstance.dismiss('cancel');
    };
    JobMatchMeetingsFeedbackModalController.prototype.refresh = function () {
        this.callbackObject.callbackType = 'refresh';
        this.modalInstance.close(this.callbackObject);
    };
    return JobMatchMeetingsFeedbackModalController;
}());
// import * as TEMPLATE from './job-match-meetings-feedback-modal.html;
import * as TEMPLATE from 'raw-loader!./job-match-meetings-feedback-modal.html';
export var JobMatchMeetingsFeedbackModalComponent = {
    selector: 'jobMatchMeetingsFeedbackModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: JobMatchMeetingsFeedbackModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/shared/jobMatchActions/jobMatchMeetings/jobMatchMeetingsFeedbackModal/job-match-meetings-feedback-modal.html'
    }
};
//# sourceMappingURL=job-match-meetings-feedback-modal.component.js.map